export enum WorkflowToken {
	ACCOUNT_CUSTOMER_EDIT = 'Account_Customer_Edit',
	ACCOUNT_CUSTOMER_EDIT_BILLING_ADDRESS = 'Account_Customer_Edit_BillingAddress',
	ACCOUNT_CUSTOMER_EDIT_SHIPPING_ADDRESS = 'Account_Customer_Edit_ShippingAddress',
	ACCOUNT_CUSTOMER_ORDER_LIST_SHOW = 'Account_Customer_Order_List_Show',
	ACCOUNT_CONTRACTOR_EDIT_CONNECTED_PURCHASERS = 'Account_Contractor_Edit_ConnectedPurchasers',
	ACCOUNT_DISPLAY_CUSTOMER_USER_MANAGEMENT = 'Account_Display_Customer_User_Management',
	ACCOUNT_LINKED_PORTALS_EDIT = 'Account_Linked_Portals_Edit',
	ACCOUNT_DENTIST_EDIT_FAVORITE_LABS = 'Account_Dentist_Edit_FavoriteLabs',
	ACCOUNT_LAB_EDIT_ADDITIONAL_ORDER_INFORMATION = 'Account_Lab_Edit_AdditionalOrderInformation',
	ACCOUNT_LAB_EDIT_CONNECT_DIRECT = 'Account_Lab_Edit_ConnectDirect',
	ACCOUNT_LAB_EDIT_LAB_PROFILE = 'Account_Lab_Edit_LabProfile',
	ACCOUNT_LAB_EDIT_OFFERINGS_AND_SERVICES = 'Account_Lab_Edit_OfferingsAndServices',
	ACCOUNT_USER_ADD = 'Account_User_Add',
	ACCOUNT_USER_ASSIGNROLE = 'Account_User_AssignRole',
	ACCOUNT_USER_EDIT = 'Account_User_Edit',
	ACCOUNT_USER_RESET_PASSWORD = 'Account_User_ResetPassword',
	ACCOUNT_USER_SELF_ADMINISTRATION = 'Account_User_SelfAdministration',
	DENTIST_ORDER_LIST_SHOW = 'Dentist_Order_List_Show',
	DENTIST_ORDER_ADDITIONALFILES_SHOW = 'Dentist_Order_AdditionalFiles_Show',
	FEATURE_CONNECTED_DENTISTS = 'Feature_ConnectedDentists',
	CONTACT_USER = 'Contact_User',
	CONNECTINBOX_WORKSTATIONS_SHOW = 'ConnectInbox_Workstations_Show',
	CONNECTINBOX_WORKSTATIONS_DELETE = 'ConnectInbox_Workstations_Delete',
	LAB_ORDER_LIST_SHOW = 'Lab_Order_List_Show',
	LAB_ORDER_ADDITIONALFILES_SHOW = 'Lab_Order_AdditionalFiles_Show',
	ORDER_LIST_FILTER = 'Order_List_Filter'
}
